<template>
  <modal
    class="editCreditLimit"
    name="LinkVehicle"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
    @closed="closed"
  >
    <div class="retainership__box">
      <div class="text-center">
        <h3 class="mt-5 add__retainership__header">
          {{ $t("text.driverModal.linkVehicle") }}
        </h3>
        <div class="add__retainership__form__wrapper">
          <div class="mt-3 form_input_section">
            <model-select
              :options="vehicles"
              v-model="vehicle"
              placeholder="select vehicle"
            >
            </model-select>
          </div>
          <div ref="email_error_message"></div>
          <div class="mt-5 text-center">
            <button
              class="add_quick_fuel_btn"
              @click="linkVehicles($event)"
              :disabled="isButtonDisabled ? true : null"
              :style="[
                isButtonDisabled
                  ? { cursor: 'not-allowed' }
                  : { cursor: 'pointer' },
              ]"
            >
              {{ $t("text.driverModal.linkVehicle") }}
            </button>
            <img
              src="@/assets/img/git_loader.gif"
              style="display: none"
              width="35px"
              class="ml-3 loader"
            />
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";

const MODAL_WIDTH = 656;

export default {
  name: "LinkVehicle",
  props: ["driverInfo"],
  components: {
    ModelSelect,
  },
  data() {
    return {
      creditLimitValue: null,
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      vehicles: [],
      vehicle: null,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  mounted() {
    this.getVehicles();
  },
  methods: {
    closed() {
      this.vehicle = null;
    },
    closeModal() {
      this.$modal.hide("LinkVehicle");
    },
    getVehicles() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Track/Vehicles`,
          configObject.authConfig()
        )
        .then((response) => {
          this.vehicles = response.data.vehicles;
          this.vehicles.forEach((vehicle) => {
            vehicle.text = `${vehicle.carType} ${vehicle.carModel} ${vehicle.plateNumber}`;
            vehicle.value = vehicle.id;
          });
        })
        .catch((error) => {});
    },
    linkVehicles($event) {
      $event.preventDefault();
      if (this.vehicleId === "link driver to vehicle") {
        this.$toast.open({
          message: "Please select a vehicle to link",
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        driverId: this.driverInfo.id,
        vehicleId: this.vehicle,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Drivers/LinkToVehicle`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          data = null;
          this.creditLimitValue = null;
          this.$modal.hide("LinkVehicle");
          this.$toast.open({
            message: "Vehicle linked successfully",
            type: "success",
            duration: 3000,
          });
          this.closeModal();
          this.$eventHub.$emit("fetchDrivers");
        })
        .catch((error) => {
          this.$modal.hide("LinkVehicle");
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
